import { render } from "./SalesSearch.vue?vue&type=template&id=315b032c&ts=true"
import script from "./SalesSearch.vue?vue&type=script&lang=ts"
export * from "./SalesSearch.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__